// Data that configures the Player Offensive Table
import { offensivePlayerTableRowItems } from '@/utils/dataTablesStructures/normalPlayer';
import { offensiveGoalkeeperTableRowItems } from '@/utils/dataTablesStructures/goalkeeperPlayer';
import baseColumns from '@/data/player/baseColumns';

export default {
  columns: baseColumns,
  expandedRows: offensivePlayerTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
  goalkeeperExpandedRows: offensiveGoalkeeperTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};
